import app from '../app.first';
import $ from 'jquery';

app.IntroduceYourself = class extends app.Component {
	constructor($this) {
        super($this);
        $(() => this.onDocumentReady($this));

	}

    onDocumentReady($this) {
        $('#iy_video_file').change(function(e) {
            $('#iy_video_filename').html(e.target.files[0].name);
        });
    }
}